var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};


function removeUrlParameter(key, sourceURL) {
	var rtn = sourceURL.split("?")[0],
		param,
		params_arr = [],
		queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
	if (queryString !== "") {
		params_arr = queryString.split("&");
		for (var i = params_arr.length - 1; i >= 0; i -= 1) {
			param = params_arr[i].split("=")[0];
			if (param === key) {
				params_arr.splice(i, 1);
			}
		}
		rtn = params_arr.length > 0
			? rtn + "?" + params_arr.join("&")
			: rtn;
	}
	return rtn;
}

// this test is only being used in the modal-when-leaving.js - 20200715 Richard
function localStorageTest(){
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    };
};

window.localStorageStatus = localStorageTest();

$(function() {
    // Run the fix immediately and also after a delay to catch any late-loading content
    function fixCorruptedBlogCards() {
        if ($('[data-showmore-limit]').length) {
        var ellipsesText = "...";

        $('.swiper-slide').each(function() {
            var $slide = $(this);
            
            var $anchorTags = $slide.find('a.card__blog');
            var hasCorruptedStructure = $anchorTags.length > 1;
            
            var slideHTML = $slide[0].innerHTML;
            var hasPatternCorruption = slideHTML.includes('</a><div class="card__bottom"><a target="_blank"');
            
            if (hasCorruptedStructure || hasPatternCorruption) {
                
                var $card = $slide.find('a.card__blog').first();
                var $orphanedCardBottom = $slide.find('div.card__bottom').not($card.find('div.card__bottom'));
                
                if ($card.length > 0 && $orphanedCardBottom.length > 0) {
                    var href = $card.attr('href');
                    var onclick = $card.attr('onclick');
                    var target = $card.attr('target');
                    var classes = $card.attr('class');
                    
                    // Get the card image
                    var $cardImage = $card.find('.card__image');
                    var $cardStyle = $card.find('style');
                    
                    // Get the content from the orphaned card__bottom
                    var $postedDate = $orphanedCardBottom.find('.posted-date');
                    var $h4 = $orphanedCardBottom.find('h4');
                    var $contentDiv = $orphanedCardBottom.find('div[data-showmore-limit]');
                    var $readMore = $orphanedCardBottom.find('.read-more');
                    
                    // Reconstruct the entire slide HTML
                    var newHTML = '<a target="' + target + '" onclick="' + onclick + '" href="' + href + '" class="' + classes + '">';
                    newHTML += $cardImage[0].outerHTML;
                    newHTML += $cardStyle[0].outerHTML;
                    newHTML += '<div class="card__bottom">';
                    newHTML += $postedDate[0].outerHTML;
                    newHTML += $h4[0].outerHTML;
                    newHTML += $contentDiv[0].outerHTML;
                    newHTML += $readMore[0].outerHTML;
                    newHTML += '</div>';
                    newHTML += '</a>';
                    
                    // Replace the entire slide content
                    $slide.html(newHTML);
                }
            }
        });

        $('[data-showmore-limit]').each(function() {

            if ($(this).hasClass('showmore-processed')) {
                return;
            }
            
            var lmt = $(this).attr('data-showmore-limit');
            var moreText = $(this).attr('data-showmore-text') ? $(this).attr('data-showmore-text') : "Show More";
            var hideText = "Hide";
            
            // Get text content only to avoid HTML corruption
            var textContent = $(this).text();
            textContent = textContent.replace(/\s+/g, ' '); // Strips unwanted spaces
            let html = '';

            if (textContent.length > lmt) {
                html += "<div class='show-content-visible'>";
                html += textContent.substring(0, lmt) + ellipsesText;
                html += "<span class='show-more-cta'>" + moreText + "</span>";
                html += "</div>";
                html += "<div class='show-content-hidden' style='display: none;'>";
                html += textContent;
                html += "<span class='hide-more-cta'>" + hideText + "</span>"; // Added "Hide" button
                html += "</div>";

                $(this).html(html);
            }
            
            $(this).addClass('showmore-processed');
        });

        // Show More Button
        $(document).on("click", ".show-more-cta", function() {
            $(this).closest('.show-content-visible').hide();
            $(this).closest('.show-content-visible').next('.show-content-hidden').show();

            if ($(this).attr('data-showmore-gaevent')) {
                gae('readmore', $(this).attr('data-showmore-gaevent'));
            } else {
                gae('readmore', 'not_specified');
            }

            return false;
        });

        // Hide Button
        $(document).on("click", ".hide-more-cta", function() {
            $(this).closest('.show-content-hidden').hide();
            $(this).closest('.show-content-hidden').prev('.show-content-visible').show();
            return false;
        });
        }
    }
    
    // Run immediately
    fixCorruptedBlogCards();
    
    // Also run after a delay to catch any late-loading content
    setTimeout(fixCorruptedBlogCards, 100);
    setTimeout(fixCorruptedBlogCards, 500);
    setTimeout(fixCorruptedBlogCards, 1000);

    $('.js-scroll-to').click(function() {
        $('html, body').stop().animate({
            scrollTop: $($(this).attr('href')).offset().top - 60
        }, 300);
        return false;
    });
});


// Close button with fadeOut + google analytics event
$(function() {
    $('.js-close-btn').click( function() {
        $(this).parents('.js-close-btn-container').fadeOut();

        var experimentName = $(this).parents('.js-close-btn-container').attr('data-experiment-name');
        if (typeof(experimentName) != 'undefined' ) { gae( experimentName,'closeButton') }

        return false;
    });
});

// Expand
$(function() {
    $('.js-expand-btn').click( function() {
        $(this).parents('.js-expand-container').toggleClass('open');
        var experimentName = $(this).parents('.js-expand-container').attr('data-experiment-name');
        return false;
    });
});


function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
}


function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
}


// Levenshtein distance https://en.wikipedia.org/wiki/Levenshtein_distance
function similarity(t,e){var r=t,n=e;t.length<e.length&&(r=e,n=t);var a=r.length;return 0==a?1:(a-editDistance(r,n))/parseFloat(a)}function editDistance(t,e){t=t.toLowerCase(),e=e.toLowerCase();for(var r=new Array,n=0;n<=t.length;n++){for(var a=n,i=0;i<=e.length;i++)if(0==n)r[i]=i;else if(i>0){var h=r[i-1];t.charAt(n-1)!=e.charAt(i-1)&&(h=Math.min(Math.min(h,a),r[i])+1),r[i-1]=a,a=h}n>0&&(r[e.length]=a)}return r[e.length]}


function shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
}


function sortByKey(array, key) {
	return array.sort(function(a, b) {
		var x = a[key];
		var y = b[key];
		return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	});
};
